import {
  elevationAngle,
  IRRADIANCEDATA,
  pvPerformance,
} from "../../../Features/irrediance";
import { roofStructureData } from "../Design&Structure/structureFunction";
import { updateRoofDetails } from "../../../Features/quantityInfo";
import { genrationVariable } from "../../../Features/customVariables";
import { panelInformation } from "../../DataFiles/panelInformation";

let array = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
];
const day = [1, 32, 59, 91, 121, 151, 182, 213, 243, 274, 304, 335, 365];

const ImageDimension = ({ structureItem, roofDetail, panel }) => {
  // Find the image Dimension
  const strInfo = structureItem;

  const orientation = roofDetail.customizeStructure
    ? roofDetail.orientation
    : strInfo.orientation;

  const rowFrame = roofDetail.customizeStructure
    ? roofDetail.blockRow
    : strInfo.rowFrame;
  const colFrame = roofDetail.customizeStructure
    ? roofDetail.blockCol
    : strInfo.colFrame;

  let width = panel.width;
  let height = panel.height;
  if (orientation === "Landscape") {
    width = panel.height;
    height = panel.width;
  }

  const angle = (roofDetail.tiltAngle * Math.PI) / 180;
  const hyp =
    height * (rowFrame + (rowFrame - 1) * (roofDetail.moduleSpacing / 1000)) +
    0.301;
  const base = hyp * Math.cos(angle);
  const perp = hyp * Math.sin(angle) * 1.5 + roofDetail.frontHeight / 1000;

  const imgDimension = {
    height: base,
    width: width * colFrame,
    gap: perp,
    rowDistance: Number(perp.toFixed(5)),
    orientation: orientation,
    rowFrame: rowFrame,
    colFrame: colFrame,
  };
  return imgDimension;
};

const mulImgDim = ({ structureItem, panel }) => {
  // Find the image Dimension
  const strInfo = structureItem;

  let width = panel.width;
  let height = panel.height;
  if (strInfo.orientation === "Landscape") {
    width = panel.height;
    height = panel.width;
  }

  const rowFrame = strInfo.rowFrame;
  const colFrame = strInfo.colFrame;

  const angle = (15 * Math.PI) / 180;
  const hyp =
    height * (rowFrame + (rowFrame - 1) * (strInfo.moduleSpacing / 1000)) +
    0.301;
  const base = hyp * Math.cos(angle);
  const perp = hyp * Math.sin(angle) * 1.5 + strInfo.frontHeight / 1000;

  const imgDimension = {
    height: base,
    width: width * colFrame,
    gap: perp,
    rowDistance: Number(perp.toFixed(5)),
    orientation: strInfo.orientation,
    rowFrame: rowFrame,
    colFrame: colFrame,
  };
  return imgDimension;
};

export const generationLosses = (roofDetail, quantityInfo, dispatch) => {
  const inverterEfficency = 0.98;
  const irradiance = IRRADIANCEDATA["Lahore"];

  let monthlyGen = [];
  let actualGen = [];
  let shadingLoss = [];
  let tiltAngleLoss = [];
  let azimuthLoss = [];
  const rowDistance = roofDetail.rowDistance;
  const azimuth = roofDetail.azimuth;
  const arr = roofDetail.images;
  let structureItem = roofStructureData.find(
    (item) => item.name === roofDetail.mountingStructure
  );
  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );
  const imgDimension = ImageDimension({ structureItem, roofDetail, panel });
  for (let j = 0; j < array.length; j++) {
    const month = array[j];
    const result = generationShadingLosses(
      structureItem,
      rowDistance,
      arr,
      elevationAngle[month],
      irradiance[month],
      day[j],
      azimuth,
      inverterEfficency,
      panel,
      roofDetail,
      imgDimension
    );
    monthlyGen.push(result.montlyGeneration);
    actualGen.push(result.actualGeneration);
    shadingLoss.push(result.shadingLosses);
    tiltAngleLoss.push(result.tiltAngleLosses);
    azimuthLoss.push(result.azimuthEnergyLosses);
  }
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: {
        montlyGeneration: monthlyGen,
        shadingLosses: shadingLoss,
        actualGeneration: actualGen,
        tiltAngleLosses: tiltAngleLoss,
        azimuthLosses: azimuthLoss,
      },
    })
  );
};

export const genLossesMultiple = (dispatch, quantityInfo, myObject) => {
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];
  const inverterEfficency = 0.98;
  const irradiance = IRRADIANCEDATA["Lahore"];
  const azimuth = roofDetail.azimuth;
  const arr = myObject.images;

  let panelInfo = panelInformation.find(
    (item) => item.brand === roofDetail.module
  );
  let panel = panelInfo.panelType.find(
    (item) => item.name === roofDetail.moduleType
  );

  let monthlyGen = [];
  let actualGen = [];
  let shadingLoss = [];
  let tiltAngleLoss = [];
  let azimuthLoss = [];

  for (let i = 0; i < array.length; i++) {
    const month = array[i];
    const result = generationMultipleShadingLosses(
      arr,
      elevationAngle[month],
      irradiance[month],
      day[i],
      azimuth,
      inverterEfficency,
      panel,
      roofDetail
    );

    monthlyGen.push(result.montlyGeneration);
    actualGen.push(result.actualGeneration);
    shadingLoss.push(result.shadingLosses);
    tiltAngleLoss.push(result.tiltAngleLosses);
    azimuthLoss.push(result.azimuthEnergyLosses);
  }
  dispatch(
    updateRoofDetails({
      index: quantityInfo.roofNo,
      fields: {
        montlyGeneration: monthlyGen,
        shadingLosses: shadingLoss,
        actualGeneration: actualGen,
        tiltAngleLosses: tiltAngleLoss,
        azimuthLosses: azimuthLoss,
      },
    })
  );
};

const generationShadingLosses = (
  structureItem,
  rowDistance,
  arr,
  elevationAngle,
  irradiance,
  day,
  azimuthAngle,
  inverterEfficency,
  panel,
  roofDetail,
  imgDimension
) => {
  const structureWatt = !structureItem
    ? imgDimension.rowFrame * imgDimension.colFrame
    : structureItem.structureWatt;

  let gap = imgDimension?.gap;
  let height = imgDimension?.height;

  if (
    !roofDetail.customizeStructure &&
    (roofDetail.roofType === "Customized Roof" ||
      roofDetail.roofType === "Carport")
  ) {
    gap = structureItem.gap;
    height = structureItem.height;
  }

  if (roofDetail.mountingStructure === "Double Carport") {
    rowDistance = roofDetail.roadSpace * 305;
  }

  const maxXValue =
    arr.length > 0 ? Math.max(...arr.map((item) => item.y)) : [];
  const resultArray = arr.filter((item) => item.y === maxXValue);

  const objectHeigth = (gap / 1.5) * 3.28084;
  const distanceBetweenRow = (rowDistance / 1000) * 3.28084;

  const panelArea = height * 3.28084;
  const panelWatts = panel.pMax;
  const shadowLength = objectHeigth / elevationAngle;
  const shadowArea = panelArea - (shadowLength - distanceBetweenRow);
  const loseArea = (1 - shadowArea / panelArea) * 100;

  let generation = 0;

  let shadingLosses = 0;

  if (loseArea >= 0 && roofDetail.roofType !== "Shed Roof") {
    const production = ((panelWatts * structureWatt) / 100) * loseArea;

    const losses = production * (arr.length - resultArray.length);
    shadingLosses = Number(
      (
        (losses / 1000) *
        irradiance *
        (panel.efficiency / 100) *
        inverterEfficency
      ).toFixed()
    );
  } else {
    shadingLosses = 0;
  }

  generation = panelWatts * structureWatt * arr.length;

  const monthlyYeild =
    (generation / 1000) * irradiance * pvPerformance * inverterEfficency;

  const yeild = Number(
    ((monthlyYeild * (100 - genrationVariable)) / 100).toFixed()
  );
  const azimuthAngleLosses =
    100 * (1 - Math.cos((azimuthAngle - 180) * 0.0174444444));

  const azimuthLosses = Number(
    ((monthlyYeild * azimuthAngleLosses) / 100).toFixed()
  );
  let tiltAngle = roofDetail?.tiltAngle ? roofDetail.tiltAngle : 15;

  if (roofDetail.roofType === "Shed Roof") {
    tiltAngle = 0;
  } else if (
    roofDetail.roofType === "Carport" ||
    roofDetail.roofType === "Customized Roof"
  ) {
    tiltAngle = 10;
  }
  const solarDeclinationAngle =
    23.45 * Math.sin(6.27999998 * ((284 + day) / 365));
  const energyLossesPerDay =
    100 * (1 - Math.cos((tiltAngle - solarDeclinationAngle) * 0.0174444444));
  const tiltLoses = Number(
    ((monthlyYeild * energyLossesPerDay) / 100).toFixed()
  );
  const generationGenrate = yeild - shadingLosses - azimuthLosses - tiltLoses;

  const data = {
    montlyGeneration: yeild,
    actualGeneration: generationGenrate > 0 ? generationGenrate : 0,
    shadingLosses: shadingLosses,
    azimuthEnergyLosses: azimuthLosses,
    tiltAngleLosses: tiltLoses,
  };

  return data;
};

const generationMultipleShadingLosses = (
  arr,
  elevationAngle,
  irradiance,
  day,
  azimuthAngle,
  inverterEfficency,
  panel,
  roofDetail
) => {
  const separatedArr = arr.reduce((acc, obj) => {
    const key = obj.y;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});

  const resultArrays = Object.values(separatedArr);

  let generation = 0;
  let shadingLosses = 0;

  for (let i = 0; i < resultArrays.length; i++) {
    const firstArr = resultArrays[i];
    const aboveArrStr = roofStructureData.find(
      (item) => item.name === firstArr[0].type
    );
    const imgDimAbove = mulImgDim({
      structureItem: aboveArrStr,
      panel,
    });
    const panelWatts = panel.pMax;
    if (i < resultArrays.length - 1) {
      const secondArr = resultArrays[i + 1];
      const belowArrStr = roofStructureData.find(
        (item) => item.name === secondArr[0].type
      );

      const imgDimBelow = mulImgDim({
        structureItem: belowArrStr,
        panel,
      });

      const distanceBetweenRow = imgDimBelow.gap;
      const objectHeigth = imgDimBelow.gap / 1.5;

      const panelArea = imgDimAbove.height;
      const panelWatts = panel.pMax;

      const shadowLength = objectHeigth / elevationAngle;
      const shadowArea = panelArea - (shadowLength - distanceBetweenRow);
      const loseArea = (1 - shadowArea / panelArea) * 100;

      if (loseArea >= 0 && roofDetail.roofType !== "Shed Roof") {
        const production =
          ((panelWatts * belowArrStr.structureWatt) / 100) * loseArea;

        const losses = production * firstArr.length;
        shadingLosses += Number(
          (
            (losses / 1000) *
            irradiance *
            (panel.efficiency / 100) *
            inverterEfficency
          ).toFixed()
        );
      } else {
        shadingLosses += 0;
      }
    }

    generation += panelWatts * firstArr.length * aboveArrStr.structureWatt;
  }

  const monthlyYeild =
    (generation / 1000) * irradiance * pvPerformance * inverterEfficency;

  const yeild = Number(
    ((monthlyYeild * (100 - genrationVariable)) / 100).toFixed()
  );

  const azimuthAngleLosses =
    100 * (1 - Math.cos((azimuthAngle - 180) * 0.0174444444));
  const azimuthLosses = Number(
    ((monthlyYeild * azimuthAngleLosses) / 100).toFixed()
  );
  let tiltAngle = 15;

  const solarDeclinationAngle =
    23.45 * Math.sin(6.27999998 * ((284 + day) / 365));
  const energyLossesPerDay =
    100 * (1 - Math.cos((tiltAngle - solarDeclinationAngle) * 0.0174444444));
  const tiltLoses = Number(
    ((monthlyYeild * energyLossesPerDay) / 100).toFixed()
  );

  const generationGenrate = yeild - shadingLosses - azimuthLosses - tiltLoses;

  const data = {
    montlyGeneration: yeild,
    actualGeneration: generationGenrate > 0 ? generationGenrate : 0,
    shadingLosses: shadingLosses,
    azimuthEnergyLosses: azimuthLosses,
    tiltAngleLosses: tiltLoses,
  };
  return data;
};

export const generationTiltAngleLosses = ({ tiltAngle }) => {
  let yearlyLosses = [];
  const monthArray = [1, 32, 59, 91, 121, 152, 182, 213, 244, 274, 305, 335];
  for (let i = 0; i < monthArray.length; i++) {
    const solarDeclinationAngle =
      23.45 * Math.sin(6.27999998 * ((284 + monthArray[i]) / 365));
    const energyLossesPerDay =
      100 * (1 - Math.cos((tiltAngle - solarDeclinationAngle) * 0.0174444444));
    yearlyLosses.push(energyLossesPerDay);
  }
  let totalTiltAngleLosses = Object.values(yearlyLosses).reduce(
    (sum, value) => sum + value,
    0
  );
  const avgTiltLosses = totalTiltAngleLosses / 12;

  return avgTiltLosses;
};

export const shadingLosses = (quantityInfo, dispatch, inverterEfficency) => {
  if (!inverterEfficency) {
    inverterEfficency = 0.98;
  }
  const roofData = quantityInfo?.roofData || [];
  const irradiance = IRRADIANCEDATA["Lahore"];

  for (let i = 0; i < roofData.length; i++) {
    const element = roofData[i];
    let monthlyGen = [];
    let actualGen = [];
    let shadingLoss = [];
    let tiltAngleLoss = [];
    let azimuthLoss = [];
    const rowDistance = element.rowDistance;
    const azimuth = element.azimuth;
    const arr = element.images;
    let structureItem = roofStructureData.find(
      (item) => item.name === element.mountingStructure
    );
    let panelInfo = panelInformation.find(
      (item) => item.brand === element.module
    );
    let panel = panelInfo.panelType.find(
      (item) => item.name === element.moduleType
    );
    const roofDetail = element;
    const imgDimension = ImageDimension({ structureItem, roofDetail, panel });
    for (let j = 0; j < array.length; j++) {
      const month = array[j];
      const result =
        element.structureType === "Multiple"
          ? generationMultipleShadingLosses(
              arr,
              elevationAngle[month],
              irradiance[month],
              day[j],
              azimuth,
              inverterEfficency,
              panel,
              element
            )
          : generationShadingLosses(
              structureItem,
              rowDistance,
              arr,
              elevationAngle[month],
              irradiance[month],
              day[j],
              azimuth,
              inverterEfficency,
              panel,
              element,
              imgDimension
            );
      monthlyGen.push(result.montlyGeneration);
      actualGen.push(result.actualGeneration);
      shadingLoss.push(result.shadingLosses);
      tiltAngleLoss.push(result.tiltAngleLosses);
      azimuthLoss.push(result.azimuthEnergyLosses);
    }
    dispatch(
      updateRoofDetails({
        index: i,
        fields: {
          montlyGeneration: monthlyGen,
          shadingLosses: shadingLoss,
          actualGeneration: actualGen,
          tiltAngleLosses: tiltAngleLoss,
          azimuthLosses: azimuthLoss,
        },
      })
    );
  }
};
